import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/pages/Login.vue'
import pages from './routes/pages'

Vue.use(Router)

const isLoggedInUser = localStorage.getItem('USER')
const role = localStorage.getItem('USER') && localStorage.getItem('USER') !== "null" ? JSON.parse(localStorage.getItem('USER')).role : null
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    ...pages,
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/ico/verify/:id/:token',
      redirect: to => {
        localStorage.clear()
        return { name: 'auth-register-success', query: { id: to.params.id, token: to.params.token } }
      },
    },
    {
      path: '/ico/login',
      redirect: { name: "Login"},
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/ico/login/:token',
      redirect: { name: "Login"},
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/ico/password/reset/:token',
      redirect: to => {
        localStorage.clear()
        return { name: 'auth-reset-password', query: { token: to.params.token } }
      },
    },
    {
      path: '/ico/password/confirm/:token',
      redirect: to => {
        return { name: isLoggedInUser !== "null" ? role == 0 ? 'admin-profile': 'user-profile' : 'Login', query: { token: to.params.token }}
      },
    },
    {
      path: '/ico/kyc-application',
      component: () => import('../views/pages/KycApplication.vue'),
    },
    {
      path: '/invite',
      redirect: to => {
        return { name: 'auth-register', query: { ref: to.query.ref } }
      },
    },
  ]
})

const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 0) return '/admin'
  if (userRole === 2) return '/user'
  // return { name: 'auth-login' }
}

router.beforeEach((to,  _, next) => {
  const isLoggedIn = localStorage.getItem('USER')
  const userData = JSON.parse(localStorage.getItem('USER'))

  if( isLoggedIn ) {
    if(userData && userData.role === 0 && to.path == '/user') {
      next("/admin")
    }
    if(userData && userData.role === 2 && to.path == '/admin') {
      next("/user")
    }
  }

  // if(to.meta.redirectIfLoggedIn && isLoggedIn && userData.role === 1 && to.path == '/admin') {
  //   next("/user")
  // }
  
  // if (!canNavigate(to)) {
  //   // Redirect to login if not logged in
  //   if (!isLoggedIn) return next({ name: 'auth-login' })

  //   // If logged in => not authorized
  //   return next({ name: 'misc-not-authorized' })
  // }
  // Redirect if logged in
   if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }
  return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js